import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./Switch.module.scss";
const Switch = ({ defaultChecked=false,onChange }) => {
    useEffect(() => {
    }, [])
    return (
        <label className={style.switch}>
            <input type="checkbox" defaultChecked={defaultChecked} onChange={onChange} />
            <span className={`${style.slider}`}></span>
        </label>
    );
}

export default Switch;